<template>
    <CCard>    
        <CCardBody>  
            <CCol sm="12" lg="12" style="padding-left: 0px; padding-right: 0px;">  
                <div class="content-wrapper">
                    <div id="app">
                        標籤起始編號(16碼)<ejs-textbox width="180px" style="text-align: center;" id="Major" floatLabelType="Auto"  placeholder="" v-model="e_start" :maxlength="16" ></ejs-textbox>
                        ~標籤結束編號(16碼)<ejs-textbox width="180px" style="text-align: center;" id="Major" floatLabelType="Auto"  placeholder="" v-model="e_end"  :maxlength="16"  ></ejs-textbox>
                       
                        &nbsp;&nbsp;<ejs-button cssClass="e-info" @click.native="getLBState" style="margin-bottom: 5px;">查詢</ejs-button>
                        &nbsp;&nbsp;<ejs-button cssClass="e-info" @click.native="postStatus" style="margin-bottom: 5px;">批量修正</ejs-button>
                        <ejs-tooltip ref="tooltip" target=".e-rowcell" >
                            <ejs-grid ref='refdata' :dataSource='datas' height='60vh' :allowExcelExport='true' :allowPaging='false' :allowSorting='true' :allowFiltering='true' :allowReordering='true'
                                :toolbar='toolbar' :pageSettings='pageSettings' :filterSettings='filterSettings' :selectionSettings='selectionSettings' :toolbarClick="toolbarClick"
                                :editSettings='editSettings' :recordDoubleClick="recordDoubleClick"  :beforeRender="beforeRender" :rowSelected='rowSelected' 
                                :queryCellInfo='onQueryCellInfo'>
                                <e-columns>          
                                  <e-column type='checkbox' width='60'></e-column>       
                                  <e-column field='style' headerText='標籤類型' aria-required="true"  width='160'></e-column>
                                  <e-column field='volume_no' headerText='捲號' width='160'></e-column>         
                                  <e-column field='label_no' headerText='標籤編號' :isPrimaryKey='true' width='160' ></e-column>
                                  <e-column field='state' headerText='標籤狀態' width='140'></e-column>   
                                  <e-column field='enterprise' headerText='企業名稱' width='260' ></e-column>  
                                  <e-column field='label_info' headerText='標籤內容' width='180'></e-column>                                    
                                  <e-column field='enable_id' headerText='啟動編號' width='160'></e-column>
                                  <e-column field='enable_date' headerText='啟動日期' width='180'></e-column>
                                  <e-column field='order_id' headerText='訂單編號' width='180'></e-column>
                                  <e-column field='order_date' headerText='訂單日期' width='180'></e-column>                                    
                                  <e-column field='production_id' headerText='生產編號' width='160'></e-column>
                                  <e-column field='production_date' headerText='生產日期' width='180'></e-column>
                                  <e-column field='instock_date' headerText='入庫日期' width='180'></e-column>
                                  <e-column field='invalid_id' headerText='無效編號' width='160'></e-column>
                                  <e-column field='invalid_date' headerText='無效日期' width='180'></e-column>
                                  <e-column field='deliver_id' headerText='出貨編號' width='160'></e-column>
                                  <e-column field='deliver_date' headerText='出貨日期' width='180'></e-column>
                                  <e-column field='service_years' headerText='服務年限' width='140'></e-column>
                                  <e-column field='enable_months' headerText='啟動月份' width='140'></e-column>
                                </e-columns>                              
                            </ejs-grid>
                        </ejs-tooltip>
                    </div>
                </div>
            </CCol>           
            <div class="dialog">
              <div class="control-section">
                  <ejs-dialog ref="modalDialog" :showCloseIcon='true' :isModal='true' :closeOnEscape='true' :visible='false'  
                      width='40%'>
                      <div formGroup="orderForm">                       
                        <div class="form-row">                          
                          <img :src="e_url" style='width:100%' />
                        </div>
                        <div class="form-row">
                          <div class="form-group col-md-3">
                            <span class="about-title-verify">標籤類型</span>
                            <ejs-textbox  v-if="e_selectData" v-model="e_selectData.style" :enabled="false" ></ejs-textbox>                              
                          </div>                                
                          <div class="form-group col-md-3">
                            <span class="about-title-verify">標籤捲號</span>
                            <ejs-textbox v-if="e_selectData" v-model="e_selectData.volume_no" :enabled="false"></ejs-textbox>                                
                          </div>
                          <div class="form-group col-md-3">
                            <span class="about-title-verify">標籤編號</span>
                            <ejs-textbox v-if="e_selectData" v-model="e_selectData.label_no" :enabled="false"></ejs-textbox>    
                          </div> 
                          <div class="form-group col-md-3">
                            <span class="about-title-verify">標籤狀態</span>
                            <ejs-textbox v-if="e_selectData" v-model="e_selectData.state" :enabled="false"></ejs-textbox>    
                          </div> 
                          <div class="form-group col-md-6">
                            <span class="about-title-verify">企業名稱</span>
                            <ejs-textbox v-if="e_selectData" v-model="e_selectData.enterprise" :enabled="false"></ejs-textbox>    
                          </div> 
                          <div class="form-group col-md-3">
                            <span class="about-title-verify">啟動編號</span>
                            <ejs-textbox v-if="e_selectData" v-model="e_selectData.enable_id" :enabled="false"></ejs-textbox>    
                          </div> 
                          <div class="form-group col-md-3">
                            <span class="about-title-verify">啟動日期</span>
                            <ejs-textbox v-if="e_selectData" v-model="e_selectData.enable_date" :enabled="false"></ejs-textbox>    
                          </div> 
                          <div class="form-group col-md-3">
                            <span class="about-title-verify">訂單編號</span>
                            <ejs-textbox v-if="e_selectData" v-model="e_selectData.order_id" :enabled="false"></ejs-textbox>    
                          </div> 
                          <div class="form-group col-md-3">
                            <span class="about-title-verify">訂單日期</span>
                            <ejs-textbox v-if="e_selectData" v-model="e_selectData.order_date" :enabled="false"></ejs-textbox>    
                          </div> 
                          <div class="form-group col-md-3">
                            <span class="about-title-verify">生產編號</span>
                            <ejs-textbox v-if="e_selectData" v-model="e_selectData.production_id" :enabled="false"></ejs-textbox>    
                          </div> 
                          <div class="form-group col-md-3">
                            <span class="about-title-verify">生產日期</span>
                            <ejs-textbox v-if="e_selectData" v-model="e_selectData.production_date" :enabled="false"></ejs-textbox>    
                          </div> 
                          <div class="form-group col-md-3">
                            <span class="about-title-verify">入庫編號</span>
                            <ejs-textbox v-if="e_selectData" v-model="e_selectData.bill_id" :enabled="false"></ejs-textbox>    
                          </div> 
                          <div class="form-group col-md-3">
                            <span class="about-title-verify">入庫日期</span>
                            <ejs-textbox v-if="e_selectData" v-model="e_selectData.instock_date" :enabled="false"></ejs-textbox>    
                          </div> 

                          <div class="form-group col-md-3">
                            <span class="about-title-verify">無效編號</span>
                            <ejs-textbox v-if="e_selectData" v-model="e_selectData.invalid_id" :enabled="false"></ejs-textbox>    
                          </div> 
                          <div class="form-group col-md-3">
                            <span class="about-title-verify">無效日期</span>
                            <ejs-textbox v-if="e_selectData" v-model="e_selectData.invalid_date" :enabled="false"></ejs-textbox>    
                          </div> 
                          <div class="form-group col-md-3">
                            <span class="about-title-verify">出貨編號</span>
                            <ejs-textbox v-if="e_selectData" v-model="e_selectData.deliver_id" :enabled="false"></ejs-textbox>    
                          </div> 
                          <div class="form-group col-md-3">
                            <span class="about-title-verify">出貨日期</span>
                            <ejs-textbox v-if="e_selectData" v-model="e_selectData.deliver_date" :enabled="false"></ejs-textbox>    
                          </div> 
                          <div class="form-group col-md-3">
                            <span class="about-title-verify">服務年限</span>
                            <ejs-textbox v-if="e_selectData" v-model="e_selectData.service_years" :enabled="false"></ejs-textbox>    
                          </div> 
                          <div class="form-group col-md-3">
                            <span class="about-title-verify">啟動月份</span>
                            <ejs-textbox v-if="e_selectData" v-model="e_selectData.enable_months" :enabled="false"></ejs-textbox>    
                          </div> 

                          <div class="form-group col-md-12">
                            <span class="about-title-verify">標籤內容</span>
                            <ejs-textbox v-if="e_selectData" :multiline="true" v-model="e_selectData.label_info"  :enabled="false"></ejs-textbox>    
                          </div> 
                        </div>
                      </div>                
                  </ejs-dialog>
              </div>    
           </div>
            <ejs-toast ref='toastRef' id='toast_type' :position='position'></ejs-toast>      
        </CCardBody>
    </CCard>  
</template>



<style lang="scss" src="../../scss/grid.scss"></style>
<script lang="ts">

import Vue from "vue";
import Loading from 'vue-loading-overlay';
import { ButtonComponent } from '@syncfusion/ej2-vue-buttons';
import { ToastComponent } from "@syncfusion/ej2-vue-notifications";
import { L10n, setCulture, enableRipple } from '@syncfusion/ej2-base';
import { DialogPlugin, TooltipPlugin } from '@syncfusion/ej2-vue-popups';
import { GridPlugin, DetailRow, PdfExport, ExcelExport, Sort, Edit, Page, Filter, Reorder, Toolbar, Search } from "@syncfusion/ej2-vue-grids";


setCulture('en-US');
L10n.load({
  'en-US': {
    'pager': {
      'currentPageInfo': '',
      'totalItemsInfo': '{1} to {2} of {0}',
    },
    'grid': {
        'Print': '列印',
        'Search': '搜尋'
    }
  }
});

enableRipple(true);
Vue.use(DialogPlugin);
Vue.use(TooltipPlugin);
Vue.use(GridPlugin);
Vue.use(Loading);

let Loader      = undefined;

export default {
  name: 'Department',
  components: {   
    'ejs-toast': ToastComponent,
    'ejs-button': ButtonComponent
  },
  data: function () {
    return {
      e_selectData : null,
      e_isAdd: null, 
      e_start: null, e_end: null, e_url: null,    
     
      typeDatas: [{ text : '系統自建', value : 0}, {text : '使用者自建', value : 1}],
      fields: { value: 'value', text: 'text' },
      filterSettings: { type: 'CheckBox' },
      pageSettings: { pageSizes: [10, 50, 100, 200], pageCount: 4 },
      selectionSettings: { type: 'Multiple', persistSelection: true },
      editSettings: { allowEditing: false, allowAdding: false, allowDeleting: false, showAddNewRow: false },
      toolbar: null,
      datas: null,
      position: { X: 'Right', Y: "Bottom" }, ShowBtn: false,
   
      imgPersonTemplate: function () { return { 
        template: Vue.component("imgPersonTemplate", {
        template:  `<img :src="image" style='width:80px' /></div>`,
            data: function () { return { data: {}, usermale: 'usermale', userfemale: 'userfemale' }; },
        computed: {
            image: function() {
                return this.data.image_url;
            }
        }

        })}},
    };
  },
  methods: {    
    toolbarClick: function (args) {      
      if (args.item.id == "Export") {
        this.$refs.refdata.excelExport({ fileName:'標籤狀態.xlsx' });
      }   
      if (args.item.id == "Search") {
        if ( this.e_selectData  == null) return;
        this.recordDoubleClick()
      }   
    },   
    onQueryCellInfo(args) {     
      if (args.cell) {
        args.cell.classList.add("tooltip-cell");
        args.cell.setAttribute("title", `${args.column.headerText}: ${args.data[args.column.field]}`);
      }
    },

    onChange: function(args) {
      this.e_image_provider = args.checked;
    },
    checkHeader: function() {       
      this.toolbar = this.e_state == 0 ? 
      [       
        { text: '明細', tooltipText: '明細', prefixIcon: 'e-btn-icon e-search e-icons e-icon-left', id: 'Search' }, 
        { text: '匯出', tooltipText: '匯出', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'Export' }, 
        'Print', 'Search'] : 
      [      
        { text: '明細', tooltipText: '明細', prefixIcon: 'e-btn-icon e-search e-icons e-icon-left', id: 'Search' }, 
        { text: '匯出', tooltipText: '匯出', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'Export' }, 
        'Print', 'Search']
    },
    rowSelected: function(args) {    
  
      this.e_selectData = args.data;   
      this.checkHeader();
    },    
    
    beforeRender: function (args) {
      if (args.target.closest("td")) {
        this.$refs.tooltip.content = args.target.innerText;
      }
    },
    recordDoubleClick: function () {         
      this.getLBImg();
      this.$refs.modalDialog.show();  
    },
    getLBState: function () {           
      this.showLoading();
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          //url: '/AppManager/Label?start=1601000000000001&end=1601000000000002',
          url: `/AppManager/Label?start=${this.e_start}&end=${this.e_end}`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
          this.hideLoading();         
          this.datas = response.data.datas      
          this.checkHeader();
      })
      .catch((error) => { this.showError(error, true) }
      )               
    },
    getLBImg: function () {           
      
      this.showLoading();
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          //url: '/AppManager/Label?start=1601000000000001&end=1601000000000002',
          url: `/AppManager/LabelImg?lab=${this.e_selectData.label_no}`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        this.hideLoading();  
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
        this.e_url = response.data.datas ;              
      })
      .catch((error) => { this.showError(error, true) }
      )               
    },
    postStatus: function () {           
      alert('pisss');
      
              
    },
    showError: function (error) {     
      this.hideLoading();
      if (error.response.status == 400) {
        for(var key in error.response.data.errors){      
          this.$refs.toastRef.show( { title: '警告!', content: error.response.data.errors[key][0] , cssClass: 'e-toast-warning', icon: 'e-warning toast-icons' });           
        }
        return;
      }   
      if (error.response.status == 401) {
        localStorage.removeItem('token'); this.$router.push('/login');
        return;
      }
      this.$refs.toastRef.show( { title: '錯誤!', content: error.response.status, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' });
    },
    showMsg: function (msg) {
      this.$refs.toastRef.show( { title: '訊息!', content: msg, cssClass: 'e-toast-info', icon: 'e-info toast-icons' });
    },
    showLoading() {
      Loader = this.$loading.show({
        container: this.$refs.loadingContainer,
        canCancel: true, // default false
        onCancel: this.yourCallbackMethod,
        color: 'blue',
        loader: 'bars',  // spinner, dots, bars
        width: 164,
        height: 164,
        backgroundColor: 'black',
        opacity: 0.5,
        zIndex: 999,
      });
    },
    hideLoading() {
        Loader.hide();
    }
  },
  provide: {
    grid: [PdfExport, ExcelExport, Sort, DetailRow, Edit, Page, Toolbar, Filter, Reorder, Search]
  },
  created() {
    this.checkHeader();
  },
  mounted() {
  },
  beforeUpdate() {
  },
  beforeDestroy() {
  }
}
</script>
<style>
/* 設定 CustomerName 欄位的字體顏色 */
.blue-text {
  color: blue !important;
}
</style>
<style lang="scss" src="../../scss/base.scss"></style>
